import React, { useEffect, useState } from "react";
import styled from "styled-components";
import moment from "moment";
import { useMutation } from "@apollo/react-hooks";
import { ReactComponent as CartIcon } from "../../images/Cart.svg";
import Mask from "../../images/Mask.svg";
import { CREATE_EVENT } from "../../mutation/CreateEvent";
import { hasuraClient } from "../../apolloClient";
import { EDIT_EVENT } from "../../mutation/EditEvent";
import PublishedPost from "../Popup/PublishedPost";
import { EDIT_TICKET } from "../../mutation/UpdateEventTicket";
import { EDIT_NEW_TICKETS } from "../../mutation/InsertNewTickets";
import DeletePost from "../Popup/DeletePost";
import { useHistory } from "react-router-dom";
import linkIcon from "../../images/link-arrow.svg";

const DetailsDiv = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
`;
const DetailsImageDiv = styled.div`
  width: 40%;
  height: auto;
`;
const DetailsDataDiv = styled.div`
  width: 60%;
  height: auto;
  margin-left: 40px;
`;

const DetailsImage = styled.img`
  width: 100%;
  height: auto;
`;
const EventDateTime = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0px;
  color: rgba(105, 106, 231, 1);
  margin-bottom: 0;
`;
const EventTitle = styled.h4`
  font-family: Inter;
  font-size: 20px;
  margin-top: 27px;
  margin-bottom: 11px;
  font-weight: 700;
  word-break: break-word;
`;
const EventDescription = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 25px;
  word-break: break-word;
`;
const TicketsMainDiv = styled.div`
  width: 100%;
  height: auto;
`;

const TicketDiv = styled.div`
  width: 100%;
  height: auto;
  max-width: 340px;
  display: flex;
  justify-content: space-between;
  background: url(${Mask});
  padding: 25px;
  margin-bottom: 40px;
`;

const TicketName = styled.p`
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  color: rgba(22, 31, 61, 1);
  margin-left: 10px;
  margin-bottom: 0;
  word-break: break-word;
`;

const TicketAvailable = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  margin-left: 10px;
  margin-bottom: 0;
`;

const Details = (props) => {
  const { image_url } = props.step1Value;
  const history = useHistory();

  const [CreateEventMutation] = useMutation(CREATE_EVENT, {
    client: hasuraClient,
  });

  const [EditEvent] = useMutation(EDIT_EVENT, {
    client: hasuraClient,
  });

  const [InsertNewTicket] = useMutation(EDIT_NEW_TICKETS, {
    client: hasuraClient,
  });

  const [EditTicket] = useMutation(EDIT_TICKET, {
    client: hasuraClient,
  });

  useEffect(() => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    var tempDate = new Date(props.step1Value.date_time);
    var startTime = moment(props.step1Value.start_date_time).format("hh:mm A");
    tempDate =
      tempDate.getDate() +
      " " +
      monthNames[tempDate.getMonth()].toUpperCase() +
      " • " +
      startTime;
    setDateString(tempDate);
  }, []);

  const [dateString, setDateString] = useState("");
  const [modalShow, setModalShow] = useState(false);

  const profileId = localStorage.getItem("profile_id");

  const handlePublish = () => {
    if (props.editMode) {
      let newTickets = [];
      for (
        let i = 0;
        i < props.step2Value.event_paid_ticket_details.length;
        i++
      ) {
        if (!props.step2Value.event_paid_ticket_details[i].id) {
          newTickets.push({
            ...props.step2Value.event_paid_ticket_details[i],
            event_id: props?.data?.id,
          });
        }
      }
      props.step2Value.event_paid_ticket_details.map((ticket, index) => {
        const id = ticket.id;
        let sampleTicket = {
          option_name: ticket.option_name,
          description: " ",
          price: ticket.price,
          quantity_available: ticket.quantity_available,
        };
        EditTicket({
          variables: {
            id: id,
            data: sampleTicket,
          },
        }).catch(() => {});
      });
      const values = {
        id: props.data.id,
        cover_photo: props.step1Value.image_url,
        cover_photo_path: props.step1Value.image_path,
        is_all_day: false,
        ...props.step1Value,
        location_text: props.location_text,
        council_url:props.step1Value.council_url,
        location: {
          type: "Point",
          coordinates: props.cordinate,
        },
        event_payment_type: props.step2Value.event_payment_type,
        total_attendees: props.step2Value.total_attendees,
        external_ticket_url: props.ticketUrl ? props.ticketUrl : null,
        is_ticket_required: !props?.step2Value?.is_ticket_required,
      };
      delete values.image_path;
      delete values.image_url;

      EditEvent({
        variables: values,
      })
        .then(() => {
          if (props?.modalShowD) {
            props.onPressYes();
          } else {
            setModalShow(true);
          }
        })
        .catch(() => {});

      if (newTickets.length > 0) {
        InsertNewTicket({
          variables: {
            data: newTickets,
          },
        }).catch(() => {});
      }
    } else {
      const values = {
        council_profile_id: profileId,
        cover_photo: props.step1Value.image_url,
        cover_photo_path: props.step1Value.image_path,
        is_all_day: false,
        location: {
          type: "Point",
          coordinates: props.cordinate,
        },
        ...props.step1Value,
        location_text: props.location_text,
        council_url:props.step1Value.council_url,
        event_paid_ticket_details: {
          data: [...props.step2Value.event_paid_ticket_details],
        },
        external_ticket_url: props.ticketUrl ? props.ticketUrl : null,
        event_payment_type: props.step2Value.event_payment_type,
        total_attendees: props.step2Value.total_attendees,
        is_ticket_required: !props?.step2Value?.is_ticket_required,
      };
      delete values.image_path;
      delete values.image_url;

      CreateEventMutation({
        variables: values,
      })
        .then(() => {
          setModalShow(true);
        })
        .catch(() => {});
    }
  };

  return (
    <div
      className="event-list-cover"
      style={{ marginTop: 40, padding: "0 10px 0 10px" }}
    >
      <DeletePost
        title={"Your changes will be saved. Are you sure you want to exit?"}
        cancelButtonText={"No"}
        deletePostHandler={handlePublish}
        show={props?.modalShowD}
        onHide={props?.onPressNo}
      />
      <div className="title">
        <h3>Review</h3>
        <p>Please review your event</p>
      </div>
      <DetailsDiv>
        <DetailsImageDiv>
          <DetailsImage src={image_url} />
        </DetailsImageDiv>
        <DetailsDataDiv>
          <EventDateTime>{dateString}</EventDateTime>
          <EventTitle>{props.step1Value.name}</EventTitle>
          <EventDescription>{props.step1Value.description}</EventDescription>
          {props.ticketUrl ? (
            <div className="ticket-link">
              <label>Ticket Link</label>
              <a>{props.ticketUrl} </a>
              <div className="icon">
                <a href={props.ticketUrl} target="_blank">
                  <img src={linkIcon} alt="link icon" />
                </a>
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="ticket-block-row">
            {props.step2Value.event_paid_ticket_details.map((ticket) => {
              return (
                <div className="ticket-detail-block">
                  <div className="ticket-icon">
                    <div className="icon">
                      <CartIcon />
                    </div>
                  </div>
                  <div
                    className="ticket-name"
                    style={{ alignItems: "center", display: "flex" }}
                  >
                    <div className="ticket-details-row">
                      <TicketName>{ticket.option_name}</TicketName>
                      <TicketAvailable>
                        {ticket.quantity_available + " available"}
                      </TicketAvailable>
                    </div>
                    <TicketName>$ {ticket.price}</TicketName>
                  </div>
                </div>
              );
            })}
          </div>
        </DetailsDataDiv>
      </DetailsDiv>
      <div className="event-button-row">
        <button className="back-btn" onClick={props.handleBack}>
          Back
        </button>
        <button className="next-btn" onClick={handlePublish}>
          {props.editMode ? "Save Changes" : "Publish"}
        </button>
      </div>
      <PublishedPost
        events
        editMode={props.editMode}
        show={modalShow}
        onHide={() => {
          history.push("/event");
          setModalShow(false);
        }}
      />
    </div>
  );
};

export default Details;
